import { PERSONAL_WORKSPACE_ID } from '@store/reducers/dashboard/constants'
import type { AppState } from '@store/types'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

interface ProjectParams extends Record<string, string> {
  workspaceId: string
  folderId: string
}

export const useWorkspaces = () => {
  const { workspaceId = PERSONAL_WORKSPACE_ID, folderId = '' } =
    useParams<ProjectParams>()
  const workspaces = useSelector((state: AppState) => state.dashboard)
  const current = workspaces.find((w) => w.id === workspaceId) || null

  return { workspaces, current, folderId, workspaceId }
}
